// Zet een video als adaptieve stroom aan de praat (30-9-2026). Gebruikt door filmpjes die pas na een klik verschijnen (de filmpjes op de
// homepage bij De filmpjes), waar een script in een <template> niet vanzelf loopt. Zie ook snippets/km-adaptieve-video.liquid, dat hetzelfde
// doet voor filmpjes die meteen in de pagina staan. Verwacht op de video: data-km-hls (de .m3u8-stroom van Shopify) en als noodterugval
// data-km-mp4 (de ene mp4 die Shopify in het thema doorgeeft, de grootste versie; de kleinere zijn in Liquid niet op te vragen). Safari en iPhone spelen de stroom zelf af; andere browsers krijgen hls.js
// (alleen dan geladen, van jsdelivr). Lukt dat niet, dan die ene mp4.
(function () {
  window.kmAdaptief = function (video) {
    if (!video || video._kmAdaptief) return;
    video._kmAdaptief = true;
    var hls = video.getAttribute('data-km-hls');
    var mp4 = video.getAttribute('data-km-mp4');
    function speel() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    function gewoon() {
      if (mp4) { video.src = mp4; speel(); }
    }
    if (!hls) { gewoon(); return; }
    /* Alleen Safari en iPhone spelen de stroom zelf af: de ingebouwde HLS van andere browsers zette hem soms na een seconde stil
       (gemeten 30-9-2026 in de browser van Carolien's scherm), hls.js heeft dat probleem niet. */
    var apple = /iPad|iPhone|iPod/.test(navigator.userAgent) || (/Safari/.test(navigator.userAgent) && !/Chrome|Chromium|CriOS|FxiOS|Edg|Android/.test(navigator.userAgent));
    if (apple && video.canPlayType('application/vnd.apple.mpegurl')) {
      video.addEventListener('error', gewoon, { once: true });
      video.src = hls;
      speel();
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.13/dist/hls.min.js';
    s.onerror = gewoon;
    s.onload = function () {
      if (!window.Hls || !window.Hls.isSupported()) { gewoon(); return; }
      var h = new window.Hls({ startLevel: 0, capLevelToPlayerSize: true });
      video.kmHls = h;
      h.loadSource(hls);
      h.attachMedia(video);
      h.on(window.Hls.Events.MANIFEST_PARSED, speel);
      h.on(window.Hls.Events.ERROR, function (e, d) { if (d && d.fatal) { h.destroy(); gewoon(); } });
    };
    document.head.appendChild(s);
  };
})();
